// Sticky header, reproducing the source's two-stage behaviour: the header
// pins to the top as soon as the page scrolls, then compacts once the scroll
// passes its own resting height. The source only does this above its medium
// breakpoint, so below that the header scrolls away as normal.
const MEDIUM = 992;

export default function stickyHeader() {
    const wrap = document.querySelector('.amu-head-wrap');
    const viewport = document.querySelector('.gh-viewport');

    if (!wrap || !viewport) {
        return;
    }

    const query = window.matchMedia(`(min-width: ${MEDIUM}px)`);
    let restHeight = 0;
    let ticking = false;

    // Measured without the fixed/shrink classes so it is the header's full
    // height, which is both the offset the content needs and the scroll
    // distance that triggers the shrink.
    function measure() {
        const wasFixed = document.body.classList.contains('amu-head-fixed');
        const wasShrunk = document.body.classList.contains('amu-head-shrink');

        document.body.classList.remove('amu-head-fixed', 'amu-head-shrink');
        restHeight = Math.round(wrap.getBoundingClientRect().height);
        document.body.classList.toggle('amu-head-fixed', wasFixed);
        document.body.classList.toggle('amu-head-shrink', wasShrunk);
    }

    function apply() {
        ticking = false;

        if (!query.matches) {
            document.body.classList.remove('amu-head-fixed', 'amu-head-shrink');
            viewport.style.paddingTop = '';
            return;
        }

        const scrolled = window.scrollY > 0;

        document.body.classList.toggle('amu-head-fixed', scrolled);
        document.body.classList.toggle('amu-head-shrink', window.scrollY >= restHeight);
        viewport.style.paddingTop = scrolled ? `${restHeight}px` : '';
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(apply);
        }
    }

    function onResize() {
        measure();
        apply();
    }

    measure();
    apply();

    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onResize);
    query.addEventListener('change', onResize);
}
